import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewContainerRef,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject, Subscription } from 'rxjs';
import { LocalstorageRepoService } from '@dash/randy/shared/classes/localstorage-repo.service';
import { PageEvent } from '@angular/material/paginator';

@Component({
    selector: 'app-mat-table-header-toolbar',
    templateUrl: './mat-table-header-toolbar.component.html',
    styleUrls: ['./mat-table-header-toolbar.component.scss'],
    standalone: false
})
export class MatTableHeaderToolbarComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  searchForm: FormGroup;
  @Output() keyUpEventSearchbar = new EventEmitter<KeyboardEvent>();

  @Input() dataSource: MatTableDataSource<any>;
  private key: string;

  private loaded = new BehaviorSubject<boolean>(false);
  private pageSubscription: Subscription;
  private pageInit = false;
  @Input() filterPredicate = (data, filter) => {
    const dataStr = JSON.stringify(data).toLowerCase();
    return dataStr.indexOf(filter) !== -1;
  };

  constructor(
    private fb: FormBuilder,
    private viewContainerRef: ViewContainerRef,
    private localStorageService: LocalstorageRepoService,
  ) {}

  ngOnInit(): void {
    this.key = this.viewContainerRef['_hostLView'][0].localName;

    if (!this.searchForm) {
      let filter = sessionStorage.getItem(this.key);
      this.searchForm = this.fb.group({
        data: [filter ?? '', null],
      });

      this.loaded.subscribe(data => {
        if (data) {
          this.filter(this.searchForm.get('data').value);
        }
      });
    }
  }

  keyUpEventHandler($event: KeyboardEvent): void {
    this.keyUpEventSearchbar.emit($event);
    if (this.dataSource) {
      const filterValue = (event.target as HTMLInputElement).value;
      this.filter(filterValue);
    }
  }

  filter(filterValue: string): void {
    sessionStorage.setItem(this.key, filterValue);
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dataSource']) {
      this.dataSource.filterPredicate = this.filterPredicate;
      if (this.dataSource.paginator) {
        this.initPaginationSaver();
      }
      this.loaded.next(true);
    }
  }

  clearSearchText() {
    this.searchForm.get('data').setValue('');
    this.filter('');
  }

  ngOnDestroy(): void {
    this.pageSubscription?.unsubscribe();
    this.loaded.complete();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initPaginationSaver();
    });
  }

  private pageKey() {
    return this.key + 'page';
  }

  private savePaginationData(page: PageEvent) {
    let data = { ...page };
    delete data.length;
    delete data.previousPageIndex;
    this.localStorageService.setItem(this.pageKey(), JSON.stringify(data), sessionStorage);
  }

  private getPaginationData(): {
    pageIndex: number;
    pageSize: number;
  } {
    return JSON.parse(this.localStorageService.getItem(this.pageKey(), sessionStorage));
  }

  private initPaginationSaver() {
    if (!this.dataSource.paginator) {
      console.log('No paginator');
      return;
    }
    if (!this.pageInit) {
      this.pageInit = true;
      let pageData = this.getPaginationData();
      if (pageData) {
        this.dataSource.paginator.pageSize = pageData.pageSize;
        this.dataSource.paginator.pageIndex = pageData.pageIndex;
        this.dataSource._updateChangeSubscription();
      }
    }

    this.pageSubscription && this.pageSubscription.unsubscribe();
    this.pageSubscription = this.dataSource.paginator.page.subscribe(page => {
      console.log(page);
      this.savePaginationData(page);
    });
  }
}
